// NOTE: all exported methods MUST return the '@context'
import RequestContext from '../../services/RequestContext';
import { useContext } from 'react';
import { useRouter } from 'next/router';

export const makeCanonicalURL = url => {
  const router = useRouter();

  //
  // Strip anything other than "q" or "page" query params from url
  //

  // Remove any query params
  let canonical = url.replace(new RegExp('\\?.*'), '');

  // Remove any anchors
  canonical = canonical.replace(new RegExp('#.*'), '');

  const queryParams = Object.entries(router.query);

  queryParams.forEach(query => {
    // Add "q" and/or "page" back in
    const key = query[0];
    const value = query[1];

    if (key === 'q' || key === 'page') {
      if (canonical.endsWith('/')) {
        canonical += '?';
      } else {
        canonical += '&';
      }

      // No spaces in URLs
      canonical += key + '=' + value.replaceAll(' ', '+');
    }
  });

  return canonical;
};

export const getProductLinkingData = (
  title,
  thumbnail,
  description,
  url = useRouter().asPath
) => {
  const { hostname } = useContext(RequestContext);

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: title != null ? title.replace(/"/g, '\\"') : '',
    image: thumbnail,
    description: description !== null ? description.replace(/"/g, '\\"') : '',
    url: `https://${hostname}${makeCanonicalURL(url)}`,
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      priceSpecification: {
        '@type': 'UnitPriceSpecification',
        priceCurrency: 'USD',
        priceComponentType: 'https://schema.org/Subscription',
        price: 8.0,
        billingIncrement: 1,
        unitCode: 'MON',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
          unitCode: 'MON',
        },
      },
    },
  };
};

const getSearchPageListItemsLinkingData = results => {
  const items = [];

  for (let i = 0; i < results.length; i++) {
    items.push({
      '@type': 'ListItem',
      position: i + 1,
      Item: getProductLinkingData(
        results[i].title,
        results[i].thumbnail,
        results[i].description,
        results[i].url
      ),
    });
  }

  return items;
};

export const getSearchPageLinkingData = results => {
  return {
    '@context': 'https://schema.org',
    '@type:': 'ItemList',
    ItemListElement: getSearchPageListItemsLinkingData(results),
  };
};
